var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { User } from '@/models/User';
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import AQuillEditor from '@/components/AQuillEditor/AQuillEditor.vue';
import ErrorHandler from '@/support/ErrorHandler';
let ANoteWidget = class ANoteWidget extends Vue {
    constructor() {
        super(...arguments);
        // #endregion
        // #region Class properties
        this.note = '';
        this.isLoading = true;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchUserNote();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods (api calls only)
    async saveNote() {
        try {
            this.user.include('note').update({
                note: this.note,
            });
            this.$store.dispatch('openDialog', this.dialogSuccessOptions);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async fetchUserNote() {
        try {
            const user = await new User().include('note').find(this.user.id);
            if (!user.note) {
                this.note = '';
                return;
            }
            this.note =
                typeof user.note === 'string' ? user.note : user.note.text || '';
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Getters & Setters
    get dialogSuccessOptions() {
        return {
            title: this.$tc('dialogOptions.success'),
            text: this.$tc('Note successfully saved'),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$tc('dialogOptions.button.ok'),
                },
            },
        };
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof User !== "undefined" && User) === "function" ? _a : Object)
], ANoteWidget.prototype, "user", void 0);
__decorate([
    Ref(),
    __metadata("design:type", typeof (_b = typeof AQuillEditor !== "undefined" && AQuillEditor) === "function" ? _b : Object)
], ANoteWidget.prototype, "noteEditor", void 0);
ANoteWidget = __decorate([
    Component({
        components: {
            AQuillEditor,
        },
    })
], ANoteWidget);
export default ANoteWidget;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
